<template>
  <v-layout>
    <modal-add-user-note ref="addUserNoteDialog"></modal-add-user-note>
    <v-row>
      <v-col cols="12" md="3" xl="2">
        <v-card>
          <v-card-title>
            Filtry
          </v-card-title>
          <v-card-text>
            <UsersFilters></UsersFilters>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" xl="10">
        <v-card>
          <v-card-title>
            Lista użytkowników
          </v-card-title>
          <v-card-text>
            <data-table
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="total"
                :loading="loading"
                class="row-pointer"
                @click:row="onRowClicked"
            >
              <template v-slot:top>
                <v-dialog v-model="dialogRemove" width="unset">
                  <v-card>
                    <v-card-title class="headline">
                      Czy na pewno chcesz usunąć to konto?
                    </v-card-title>
                    <v-card-text>
                      {{ editedText }}
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="onRemoveDialogClosed">
                        Anuluj
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="onRemoveConfirmed">
                        Tak
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.notes="{ item }">
                <v-tooltip top color="primary" v-if="item.notes.length">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        v-bind="attrs"
                        v-on="on"
                        label
                        small
                        color="primary"
                    >
                      ?
                    </v-chip>
                  </template>
                  <div>
                    <p v-for="note in item.notes" :key="note">{{ note.note }}</p>
                  </div>
                </v-tooltip>
              </template>
              <template v-slot:item.email="{ item }">
                <span
                    :style='"display: block; padding: 5px;background:" + item.color'
                    v-html="emailLink(item.email)"
                    @click="onEmailClicked"
                ></span>
              </template>
              <template v-slot:item.companyId="{ item }">
                <router-link :to="{name: 'company-details', params: { id: item.companyId }}">
                  Przejdź ...
                </router-link>
              </template>
              <template v-slot:item.roles="{ item }">
                <v-sheet
                    max-width="170"
                    color="transparent"
                    class="mx-auto"
                    @click="onSlideGroupContainerClicked"
                >
                  <v-slide-group>
                    <v-slide-item
                        v-for="(role, i) in item.roles"
                        :key="i"
                    >
                      <v-chip
                          label
                          small
                          class="mx-1"
                          color="primary"
                      >
                        {{ role }}
                      </v-chip>
                    </v-slide-item>
                  </v-slide-group>
                </v-sheet>
              </template>
              <template v-slot:item.confirmed="{ item }">
                <span v-html="formatConfirmed(item.confirmed)"></span>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ localDateTime(item.createdAtDto) }}
              </template>
              <template v-slot:item.deletedAt="{ item }">
                {{ localDateTime(item.deletedAt) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn primary @click.stop="$refs.addUserNoteDialog.open(item.id)">Notatki</v-btn>
                <v-icon
                    v-if="canBeRemoved(item)"
                    small
                    :disabled="!!item.processed"
                    @click="onRemoveBtnTriggered(item, $event)"
                    title="Usuń konto."
                >
                  mdi-delete
                </v-icon>
              </template>
            </data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import api from '../services/api';
import formatters from '@/mixins/formatters';
import {getYesNoName} from '@/enums/YesNo';
import UsersFilters from '@/components/users/UsersFilters';
import DataTable from '@/components/data-table/DataTable';
import filters from '@/mixins/filters';
import {getDatatableParams, setDatatableOptions} from '@/utils/helpers';
import ModalAddUserNote from "@/components/ModalAddUserNote.vue";

export default {
  mixins: [
    filters,
    formatters,
  ],
  components: {
    ModalAddUserNote,
    UsersFilters,
    DataTable,
  },
  data() {
    return {
      total: 0,
      items: [],
      loading: false,
      options: {},
      headers: [
        {text: 'Login', value: 'username', sortable: false},
        {text: 'Email', value: 'email', sortable: false},
        {text: '', value: 'notes', sortable: false},
        {text: 'Imię', value: 'name', sortable: false},
        {text: 'Nazwisko', value: 'surname', sortable: false},
        {text: 'Telefon', value: 'phone', sortable: false},
        {text: 'Firma', value: 'companyId', sortable: false},
        {text: 'Role', value: 'roles', sortable: false},
        {text: 'Potwierdzony', value: 'confirmed', sortable: false},
        {text: 'Zarejestrowano', value: 'createdAt', sortable: false},
        {text: 'Usunięto', value: 'deletedAt', sortable: false},
        {text: 'Akcje', value: 'actions', sortable: false},
      ],
      filters: {},
      dialogRemove: false,
      editedIndex: -1,
      editedText: '',
      editedEvent: null,
      urlRemove: '/api/users/{id}',
    }
  },
  mounted() {
    const self = this;

    this.$root.$on('loadUsers', (options) => {
      self.load(options);
    });
  },
  watch: {
    options: {
      handler() {
        this.load();
        setDatatableOptions.call(this);
      },
      deep: true,
    },
  },
  methods: {
    appendFilters(params, filters) {
      if (!(filters instanceof Object)) {
        return;
      }

      this.appendStringFilterIfNonEmpty(params, 'confirmed', filters.confirmed);
      this.appendStringFilterIfNonEmpty(params, 'companyType', filters.companyType);
      this.appendStringFilterIfNonEmpty(params, 'email', filters.email);
      this.appendStringFilterIfNonEmpty(params, 'name', filters.name);
      this.appendStringFilterIfNonEmpty(params, 'surname', filters.surname);
      this.appendBoolFilterIfNonEmpty(params, 'showGuests', filters.showGuests);
      this.appendBoolFilterIfNonEmpty(params, 'onlyHavingFbIds', filters.onlyHavingFbIds);
      this.appendBoolFilterIfNonEmpty(params, 'showDeleted', filters.showDeleted);
    },
    canBeRemoved(item) {
      if (item.deletedAt) {
        return false; // Already cancelled.
      }

      const identity = this.$store.state.user.identity;

      if (item.id === identity.userId) {
        return false; // Cannot remove own account.
      }

      if (item.roles.includes('ROLE_DEVELOPER') ||
          item.roles.includes('ROLE_SUPER_ADMIN') ||
          item.roles.includes('ROLE_ADMIN') ||
          item.roles.includes('ROLE_GUEST')
      ) {
        return false; // Cannot remove such accounts.
      }

      if (!identity.roles.includes('ROLE_DEVELOPER') &&
          !identity.roles.includes('ROLE_SUPER_ADMIN') &&
          !identity.roles.includes('ROLE_ADMIN')
      ) {
        return false; // Not privileged to perform such action.
      }

      return true;
    },
    removeItem(item, event = null) {
      this.editedIndex = this.items.indexOf(item);
      this.editedText = [`${item.name} ${item.surname}`, item.email].filter(Boolean).join(', ');
      this.editedEvent = event;
      this.dialogRemove = true;
    },
    remove(item, event = null, index = null) {
      if (this.loading) {
        return;
      }

      let $icon = null;

      if (event) {
        $icon = event.target;

        // The following line is required to avoid triggering onRowClicked() method.
        event.cancelBubble = true;
      }

      if (item.processed) {
        return;
      }

      const id = item.id;
      item.processed = true;

      if ($icon) {
        $icon.disabled = true;
        $icon.classList.add('v-icon--disabled');
      }

      api.delete(this.urlRemove.replace('{id}', id))
          .then((response) => {
            const showRemoved = !!this.filters.showRemoved;

            if (showRemoved) {
              // TODO.
              item.username = response.data.username;
              item.email = response.data.email;
              item.name = response.data.name;
              item.surname = response.data.surname;
              item.phone = response.data.phone;
              item.companyId = response.data.companyId;
              item.roles = response.data.roles;
              item.confirmed = response.data.confirmed;
              item.deletedByUserId = response.data.deletedByUserId;
              item.deletedAt = response.data.deletedAt;
            } else {
              // The table is not displaying such statuses.
              this.items.splice(index, 1);
              this.total--;

              if (!this.items.length) {
                this.items.page--;
              }
            }

            this.onRemoveDialogClosed();

            if (this.isAccountRemoved(item)) {
              this.$root.$emit('notifySuccess', {
                html: `Konto zostało pomyślnie usunięte.`,
              });
            } else {
              this.$root.$emit('notifyError', {
                html: `Nie udało się usunąć konta - serwer obsłużył żądanie, ale nie wyzerował konta.`,
              });
            }
          })
          .catch((error) => {
            if ($icon) {
              $icon.disabled = false;
              $icon.classList.remove('v-icon--disabled');
            }

            this.$root.$emit('notifyError', {
              html: 'Nie udało się usunąć konta.',
              error,
            });
          })
          .finally(() => {
            delete item.processed;
          });
    },
    load(options = {}) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      options = options || {};

      let filters = {};
      this.appendFilters(filters, options.filters || this.filters);
      this.filters = filters; // Remember them.

      const {page, itemsPerPage} = this.options;

      const params = {
        ...filters,
        offset: page > 1 ? itemsPerPage * (page - 1) : 0
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      api.get('/api/users', {params})
          .then((response) => {
            this.items = response.data.items;
            this.total = response.data.total;

            if (options.onSuccess) {
              options.onSuccess();
            }
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać listy użytkowników.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    formatConfirmed(confirmed) {
      const className = '1' === confirmed ? 'green--text' : 'red--text';
      const text = getYesNoName('1' === confirmed);

      return `<span class="${className}">${text}</span>`;
    },
    isAccountRemoved(item) {
      return !!item.deletedAt;
    },
    stopRowClickPropagation(event) {
      // The following line is required to avoid triggering onRowClicked() method.
      event.cancelBubble = true;
      event.stopPropagation();
    },
    onEmailClicked(event) {
      // The following line is required to avoid triggering onRowClicked() method.
      event.cancelBubble = true;
      event.stopPropagation();

      return false;
    },
    onRowClicked(user) {
      this.$router
          .push({name: 'user-details', params: {id: user.id}})
          .catch((error) => {
            if (String(error).includes('Avoided redundant navigation to current location')) {
              return;
            }

            throw error;
          });
    },
    onSlideGroupContainerClicked(event) {
      // The following line is required to avoid triggering onRowClicked() method.
      event.cancelBubble = true;
      event.stopPropagation();
    },
    onRemoveBtnTriggered(item, event) {
      this.stopRowClickPropagation(event);
      this.removeItem(item, event);
    },
    onRemoveConfirmed() {
      const index = this.editedIndex;
      const item = this.items[index];
      this.remove(item, this.editedEvent, index);
    },
    onRemoveDialogClosed() {
      this.dialogRemove = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedText = '';
      });
    },
  },
  created() {
    getDatatableParams.call(this);
    this.load();
  }
}
</script>
<style lang="scss">
@import '~vuetify/src/components/VSlideGroup/_variables.scss';

// $slide-group-prev-basis: 10px;
</style>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>